import type { Translator } from "../types/nav";

/** A `<Select>` option: a stable value plus a display label. */
export interface ISelectOption {
  value: string;
  label: string;
}

/** Translation key for an enum value under `prefix` (e.g. `rewards.status.active`). */
export function enumValueKey(prefix: string, value: string): string {
  return `${prefix}.${value.toLowerCase()}`;
}

/** Builds translated select options from a string-valued enum object. */
export function enumOptions(
  enumObject: Record<string, string>,
  prefix: string,
  t: Translator,
): ISelectOption[] {
  return valueOptions(Object.values(enumObject), prefix, t);
}

/** Builds translated options from a list of raw enum value strings. */
export function valueOptions(values: readonly string[], prefix: string, t: Translator): ISelectOption[] {
  return values.map((value) => ({ value, label: t(enumValueKey(prefix, value)) }));
}

/**
 * Chart series colors as Tailwind `fill-*` utilities over the shared preset's
 * palette tokens (recharts applies `className` to each SVG shape).
 */
export const CHART_FILL_CLASSES: readonly string[] = [
  "fill-ticketon-blue",
  "fill-ticketon-lighter-blue",
  "fill-ticketon-success",
  "fill-ticketon-warning",
  "fill-ticketon-error",
  "fill-ticketon-dark-blue",
  "fill-orange-dark",
  "fill-ticketon-green",
  "fill-ticketon-gold",
  "fill-ticketon-sky-blue-bright",
];

/** The chart fill class for a series index, wrapping around the palette. */
export function chartFillClass(index: number): string {
  return CHART_FILL_CLASSES[index % CHART_FILL_CLASSES.length] ?? "fill-ticketon-blue";
}
